import { Map } from 'immutable';

import { Stream } from 'OPENTOK/models';

import { CREATE_STREAM, DESTROY_STREAM, STREAM_PROPERTY_CHANGED } from 'OPENTOK/action_types';

const streams = (state = new Map({}), action) => {
  switch (action.type) {
    case CREATE_STREAM:
      return state.set(action.id, new Stream({ id: action.id, ...action.payload }));
    case DESTROY_STREAM:
      return state.delete(action.id);
    case STREAM_PROPERTY_CHANGED:
      return state.update(
        action.id,
        (stream) => (stream ? stream.mergeDeep(action.payload) : stream),
      );
    default:
      return state;
  }
};

export default streams;
